/* Страница объекта. На компьютере прокручивается только таблица;
   на телефоне — вся страница, а отбор и поиск остаются сверху. */
.page {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

/* ── Шапка объекта ── */

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 20px;
  padding: 24px 28px 16px;
}


.heading { flex: 1; min-width: 220px; }

.titleRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
}

.title {
  margin: 0;
  font-size: 26px;
  font-weight: 650;
  line-height: 1.2;
  letter-spacing: -.01em;
  color: var(--text);
}

.summary {
  margin: 4px 0 0;
  font-size: 14px;
  color: var(--text2);
}

.actions { display: flex; flex-wrap: wrap; gap: 8px; }

.short { display: none; }

/* ── Отбор и поиск ── */

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  padding: 0 28px 12px;
}

.filters { display: flex; flex-wrap: wrap; gap: 6px; }

.chip {
  height: 30px;
  padding: 0 12px;
  font-size: 13px;
  color: var(--text2);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-pill);
  cursor: pointer;
}

.chip:hover { color: var(--text); border-color: var(--slate-lt); }

.chipOn,
.chipOn:hover {
  color: var(--blue);
  background: var(--blue-lt);
  border-color: color-mix(in srgb, var(--blue) 35%, transparent);
}

:global(html.dark) .chipOn { color: var(--navy-accent); }

.rowCount {
  font-size: 13px;
  color: var(--text2);
  font-variant-numeric: tabular-nums;
}

.search { width: 240px; margin-left: auto; }

.notice {
  margin: 0 28px 12px;
  padding: 10px 14px;
  font-size: 13.5px;
  color: var(--text2);
  background: var(--table-even);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}

/* ── Таблица ── */

.wrap {
  flex: 1;
  margin: 0 28px 24px;
  overflow: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.table {
  width: 100%;
  font-size: 13.5px;
  border-collapse: collapse;
}

.table th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text2);
  text-align: left;
  white-space: nowrap;
  background: var(--card-bg);
  box-shadow: inset 0 -1px 0 var(--border);
}

.sortButton {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 10px 12px;
  font: inherit;
  color: inherit;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
}

.sortButton:hover { color: var(--text); }

.sortMark { min-width: 10px; color: var(--blue); }

.table td {
  padding: 10px 12px;
  color: var(--text);
  vertical-align: top;
  border-bottom: 1px solid var(--border);
}

.table tbody tr { cursor: pointer; }
.table tbody tr:last-child td { border-bottom: none; }
.table tbody tr:hover td,
.table tbody tr:focus-visible td { background: var(--table-hover); }
.table tbody tr:focus-visible { outline: 2px solid var(--blue); outline-offset: -2px; }

/* Слева у строки — цвет состояния, как на полоске объекта */
.rowIssue td:first-child { box-shadow: inset 3px 0 0 var(--led-open); }
.rowIssue.rowDone td:first-child { box-shadow: inset 3px 0 0 var(--led-checked); }
.rowDone td { color: var(--text2); }

.checkCell {
  width: 52px;
  text-align: center !important;
}

.table th.checkCell { padding: 10px 0; }

.checkCell input { width: 16px; height: 16px; cursor: pointer; accent-color: var(--blue); }
.checkCell input:disabled { cursor: default; }

.mono { font-family: var(--mono); font-size: 12.5px; white-space: nowrap; }
.muted { color: var(--slate-lt); }

.issues { display: flex; flex-wrap: wrap; gap: 4px; min-width: 200px; }

.issue {
  padding: 1px 7px;
  font-size: 12px;
  line-height: 18px;
  color: var(--err);
  white-space: nowrap;
  background: var(--err-bg);
  border-radius: 4px;
}

.rowDone .issue { color: var(--text2); background: var(--table-even); }

.clean { font-size: 12.5px; color: var(--ok); }

.empty {
  padding: 48px 20px;
  font-size: 14px;
  color: var(--text2);
  text-align: center;
}

/* Второстепенные колонки скрываются, когда таблице тесно. Ширина
   считается по самой таблице, а не по окну: рядом с ней две панели. */
.wrap { container-type: inline-size; }

@container (max-width: 1180px) {
  .colSecondary { display: none; }
}

/* ── Карточки коммутаторов — только телефон ── */
.cards { display: none; }

@media (max-width: 699px) {
  .page { overflow-y: auto; }

  .header { gap: 12px; padding: 16px 16px 12px; align-items: flex-start; }
  .heading { min-width: 0; }
  .title { font-size: 22px; }

  /* Действия — одним рядом поровну, с короткими подписями */
  .actions { flex-wrap: nowrap; width: 100%; }
  .actions > * { flex: 1 1 0; justify-content: center; min-width: 0; padding: 0 8px; }
  .long { display: none; }
  .short { display: inline; }

  /* Отбор и поиск — закреплены сверху при прокрутке */
  .toolbar {
    position: sticky;
    top: 0;
    z-index: 2;
    gap: 8px 10px;
    padding: 8px 16px 10px;
    background: var(--bg);
    border-bottom: 1px solid var(--border);
  }

  .search { order: -1; width: 100%; height: 40px; margin-left: 0; font-size: 16px; }
  .rowCount { margin-left: auto; }
  .notice { margin: 12px 16px 0; }

  .wrap,
  .empty { display: none; }

  .wrap:has(.empty) { display: block; margin: 12px 16px; }
  .wrap:has(.empty) .empty { display: block; }

  .cards {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0;
    padding: 12px 16px 24px;
    list-style: none;
  }

  .card {
    position: relative;
    background: var(--card-bg);
    border: 1px solid var(--border);
    border-radius: 14px;
    overflow: hidden;
  }

  /* Слева — цвет состояния, как у строки таблицы */
  .cardOpen { box-shadow: inset 4px 0 0 var(--led-open); }
  .cardChecked { box-shadow: inset 4px 0 0 var(--led-checked); }

  .cardOpenButton {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    padding: 12px 56px 12px 16px;
    font: inherit;
    color: var(--text);
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .cardOpenButton:active { background: var(--table-hover); }
  .cardOpenButton:focus-visible { outline: 2px solid var(--blue); outline-offset: -2px; border-radius: 14px; }

  .cardName {
    font-family: var(--mono);
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -.01em;
  }

  .cardMeta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 10px;
    font-size: 13.5px;
  }

  .cardTag {
    padding: 1px 8px;
    font-size: 12.5px;
    color: var(--text2);
    background: var(--table-even);
    border-radius: var(--r-pill);
  }

  .cardPlace {
    display: -webkit-box;
    overflow: hidden;
    font-size: 13.5px;
    line-height: 1.4;
    color: var(--text2);
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .cardIssues { margin-top: 2px; }

  .cardChecked .cardName { color: var(--text2); }

  /* «Обработано» — крупная отметка в углу, мимо не промахнуться пальцем */
  .cardDone {
    position: absolute;
    top: 4px;
    right: 4px;
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    cursor: pointer;
  }

  .cardDone input { width: 22px; height: 22px; margin: 0; accent-color: var(--blue); cursor: pointer; }

  .cardDoneMark {
    position: absolute;
    top: 13px;
    right: 14px;
    font-size: 12px;
    color: var(--text2);
  }
}
